



















































































































































import { Component, Vue, Watch } from "@/shared/vuepack";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { Address, HsabExpenseCategory, HsabExpenseFormStep, } from "@/shared/types";
import _ from "lodash";
import moment from "moment/moment";
import { formatCurrency } from "@/shared/currency.js";
import { useContactInfoStore } from "@/shared/store/contactinfo";
import { useHsabExpenseFormStore } from "@/employee/store/hsabExpenseForm";
import { isNullEmptyOrUndefined } from "@/shared/stringHelper";

@Component({
  methods: {isNullEmptyOrUndefined},
  components: {
    GenericLoadingSpinner
  }
})
export default class HsabExpenseSubmitConfirmation extends Vue {
  contactInformationStore = useContactInfoStore();
  hsabExpenseFormStore = useHsabExpenseFormStore();
  formatCurrency = formatCurrency;

  get expense () {
    return this.hsabExpenseFormStore.expense;
  }

  get expenseForm () {
    return this.hsabExpenseFormStore.expenseForm;
  }

  get isSaving () {
    return this.hsabExpenseFormStore.isSaving;
  }

  @Watch("expenseForm.isPayToPayee")
  updateContactInfo () {
    if (!this.expenseForm.isPayToPayee) {
      this.contactInformationStore.getContactInformation();
    }
  }
  get showCategoryInReview () {
    return this.expenseForm.expenseCategory !== undefined
        && this.expenseForm.expenseCategory !== null
        && this.expenseForm.expenseCategory !== HsabExpenseCategory.Unknown;
  }

  get showExpenseTypeInReview () {
    return this.expenseForm.expenseType !== undefined
        && this.expenseForm.expenseType !== null
        && this.expenseForm.expenseType !== "";
  }

  get showExpenseSubTypeInReview () {
    return this.expenseForm.expenseSubType !== undefined
        && this.expenseForm.expenseSubType !== null
        && this.expenseForm.expenseSubType !== "";
  }

  get showExpenseSchedule () {
    return !isNullEmptyOrUndefined(this.hsabExpenseFormStore.scheduleDescription);
  }

  get allFilesForReview () {
    let results = _.map(this.expenseForm.stagedFilesForUpload, x => x.name);

    if (this.expense && this.expense.expenseEvidence) {
      const existingEvidence = this.expense.expenseEvidence;
      const existingFileNames = _.map(existingEvidence, e => e.fileName);
      results = results.concat(existingFileNames);
    } else {
      if (this.hsabExpenseFormStore.checkedShoeboxExpenseEvidence) {
        const shoeboxReceipts = _.map(this.hsabExpenseFormStore.checkedShoeboxExpenseEvidence, x => x.displayFileName);
        results = results.concat(shoeboxReceipts);
      }
    }

    return results;
  }

  get formattedServiceDate () {
    return moment(this.expenseForm.dateOfService).format("MMMM DD, YYYY");
  }

  get sendPaymentTo () {
    if (this.expenseForm.isPayToPayee) {
      return this.expenseForm.payeeName;
    } else {
      return this.hsabExpenseFormStore.subscriberDisplay;
    }
  }
  get mailingAddress (): Address {
    if (!this.contactInformationStore
        || !this.contactInformationStore.contactInformation
        || !this.contactInformationStore.contactInformation.mailingAddress) {
      return null;
    }

    return this.contactInformationStore.contactInformation.mailingAddress;
  }

  truncateFileName (filename) {
    const maxLength = 30;
    const postfixCharacterCount = 7;
    if (filename.length > maxLength) {
      return filename.slice(0, maxLength - (postfixCharacterCount + 3)) + "..." +
          filename.slice(filename.length - postfixCharacterCount, filename.length);
    }
    return filename;
  }

  onConfirmSubmitClicked () {
    this.$emit("confirmSubmit");
  }

  onBackClicked () {
    this.hsabExpenseFormStore.navigateBack();
  }
}
